// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;150</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;Alleluia.<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;O praise God in his holiness;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;praise him in the firmament of his power.<br> </p> </div></div>";
// Exports
module.exports = code;